import React from 'react';
import {Articles} from 'api';
import {NoContent} from 'components/no-content';
import {withRouter} from 'react-router-dom';
import {CategoryMenu} from 'components/category';
import style from './cms.scss';

class CMSContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  render() {
    return (
      <div className='center cms-container all-categories'>
        <div className='left-content'>
          <CategoryMenu/>
        </div>
        <div className='cms-right-content'>
          <section className="cms-detail p15 mb30">
            <h2 className='cms-detail-title'>{this.props.article && this.props.article.title}</h2>

            {
              this.props.article !== [] ? (
                <div className='center cms-detail-content'>

                  <div className='cms-content mb0' dangerouslySetInnerHTML={{__html:(this.props.article && this.props.article.content)}} />
                </div>
              ) : (
                <div className='center'>
                  <NoContent content='Không tìm thấy nội dung này.'/>
                </div>
              )
            }
          </section>
        </div>
      </div>
    );
  }
}

export default CMSContent;



// WEBPACK FOOTER //
// ./components/cms/CMSContent.jsx